/**
 * Copyright © Born, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('Born_MapClub/js/model/payment/mapclub',['ko'], function (ko) {
    'use strict';

    var mapclubConfig = window.checkoutConfig.payment.mapclub;
    return {
        isLoggedIn: ko.observable(mapclubConfig.isLoggedIn),
        isAvailable: ko.observable(mapclubConfig.isAvailable),
        availablePoints: ko.observable(mapclubConfig.availablePoints),
        displayPoints: function (points) {
            var separator = '.';
            points += '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(points)) {
                points = points.replace(rgx, '$1' + separator + '$2');
            }

            return points;
        },
        usedPoints: ko.observable(mapclubConfig.usedPoints),
        conversionRate: ko.observable(mapclubConfig.conversionRate),
        isApplied: ko.observable(mapclubConfig.usedPoints),
        noticeText: ko.observable(mapclubConfig.noticeText)
    };
});

